<template>
  <div style="padding-bottom: 64px;">
    <van-nav-bar
      title="工作经历"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft">
    </van-nav-bar>
    <div class="form">
      <van-cell-group class="form-cont">
        <van-field
          input-align="right"
          readonly
          @click="showPicker = true"
          is-link
          :value="wanted"
          placeholder="请选择期望职位"
          label="公司名称">
        </van-field>

        <van-field
          input-align="right"
          value=""
          placeholder="请填写职位名称"
          label="职位名称">
        </van-field>

        <van-field
          input-align="right"
          readonly
          is-link
          clickable
          placeholder="请选择在职时间"
          label="在职时间">
          <template #input>
            <div class="work-time">
              <span @click="showTimeSelect = true">{{enterTime}}</span> -
              <span @click="showTimeSelect = true">{{leaveTime}}</span>
            </div>
          </template>
        </van-field>

        <van-field
          input-align="right"
          readonly
          clickable
          is-link
          placeholder="请选择所属行业"
          @click="showPicker = true"
          label="所属行业">
        </van-field>

        <van-field
          input-align="right"
          readonly
          @click="showPicker = true"
          is-link
          placeholder="请选择当前月薪"
          clickable
          label="当前月薪">
        </van-field>
        <van-field
          input-align="right"
          class="flex-column"
          readonly
          label="工作描述">
          <template #input>
            <textarea class="area" placeholder="请描述你在该公司的主要工作内容～" >
        </textarea>
          </template>
        </van-field>
      </van-cell-group>
      <div class="status">
        <p>对这家公司隐藏我的简历</p>
        <div>
          <span>关闭</span>
          <van-switch v-model="checked" />
        </div>
      </div>
    </div>

    <div class="fixed-bottom">
      <van-button type="primary" class="btn-blue" color="linear-gradient(to right top, #2F72F6,#1C54CF)" round>保 存</van-button>
    </div>

    <!--弹出选项-->
    <van-popup v-model="showPicker" position="bottom" style="width: 100%;">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>

    <!--选择时间-->
    <van-popup v-model="showTimeSelect" position="bottom" style="width: 100%;">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        @confirm="onConfirmEnterTime"
        :formatter="formatter"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'intention',
  data() {
    return {
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      enterTime: '入职时间',
      showTimeSelect: false,
      checked: false,
      wanted: '行政专员',
      columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
      showPicker: false,
      leaveTime: '离职时间'
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    onConfirm(value) {
      this.value = value
      this.showPicker = false
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      }
      return val
    },
    onConfirmEnterTime() {
      this.enterTime = this.currentDate.getFullYear() + '-' +
        (Number(this.currentDate.getMonth()) + 1) +
        '-' +
        this.currentDate.getDate()
      this.showTimeSelect=false
    },
    onConfirmleaveTime() {
      this.leaveTime = this.currentDate.getFullYear() + '-' +
        (Number(this.currentDate.getMonth()) + 1) +
        '-' +
        this.currentDate.getDate()
        this.showTimeSelect=false
    }
  }
}
</script>

<style lang="less" scoped>
  .user-img{
    position: relative;
    width: 88px;
    margin:20px auto 40px;
    img{
      width: 88px;
      height: 88px;
    }
    i{
      position: absolute;
      right:0;
      top:0;
      color:#2F72F6;
      font-size: 22px;
    }
  }
  /deep/.van-cell{
    padding:20px 16px;
  }
  /deep/.van-hairline--top-bottom::after,/deep/.van-hairline-unset--top-bottom::after{
    display: none;
  }
  /deep/.van-cell__right-icon{
    transform: rotate(90deg);
    top:-4px;
  }
  .flex-column{
    display: flex;
    flex-direction: column;
    /deep/.van-cell__value{
      margin-right: 0;
    }
    textarea{
      margin-top: 10px;
      font-size: 14px;
      border-radius: 4px;
      background: #F8F9FB;
      padding:16px;
      color:#333;
      display: block;
      width: 100%;
      border:none;
      min-height: 105px;
      line-height: 1.8;
      &::-webkit-input-placeholder{
        color:#aaa;
      }
    }
  }
  .fixed-bottom{
    padding:10px 16px 20px;
    button{
      flex:2;
    }
    .btn-org-border{
      border:1px solid #FF5945!important;
      box-shadow: none;
      margin-right: 16px;
      flex:1;
      color:#FF5945;
      .van-button__text{
        color:#FF5945;
      }
    }
  }
  .status{
    display: flex;
    margin:0 16px;
    justify-content: space-between;
    align-items: center;
    position: relative;
    &>div{
      display: flex;
      align-items: center;
      span{
        margin-right: 10px;
        color:#BFC1C6
      }
    }
    p{
      font-size: 14px;
      color:#515255;
    }
    /deep/.van-switch{
      width: 46px;
      height: 24px;
      .van-switch__node{
        width: 20px;
        height: 20px;
      }
      &.van-switch--on{
        .van-switch__node{
          right:15px;
          left:auto;
          top:2px;
        }
      }
      .van-switch__node{
        left:2px;
        top:1px;
      }
    }
  }
</style>
